module.exports = __webpack_public_path__ + "static/media/person-1.c36af01c.jpg";